import { graphql } from "gatsby"
import React from "react"

import CoreListAtom from "@knowit-alma/common/src/components/atoms/CoreList/CoreList"

const CoreList = ({ innerHTML }) => {
  return <CoreListAtom html={innerHTML} />
}

export const query = graphql`
  fragment CoreList on WpBlockCoreList {
    __typename
    innerHTML
  }
`

export default CoreList
